import actions from './actions';

const { UPDATE_FILTERS, READ_BEGIN, READ_SUCCESS, READ_ERR, RUN_TRIGGER, UPDATE_PROFILE_PHOTO_TRIGGER } = actions;

const initialStateFilter = {
  data: [],
  loading: false,
  error: null,
  filters: {},
  trigger: undefined,
  updateTrigger: false,
};

const Reducer = (state = initialStateFilter, action) => {
  const { type, data, err, filters } = action;
  switch (type) {
    case UPDATE_FILTERS:
      return {
        ...state,
        filters,
      };
    case READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };
    case READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case RUN_TRIGGER:
      return {
        ...state,
        trigger: !state.trigger,
      };
    case UPDATE_PROFILE_PHOTO_TRIGGER:
      return {
        ...state,
        updateTrigger: !state.updateTrigger,
      };
    default:
      return state;
  }
};

export { Reducer };
